export function captureParams(inventory) {
  const params = new URLSearchParams();
  if (!inventory) return params;
  const fields = {
    capture_uuid: inventory.capture_uuid,
    proveedor: inventory.proveedor,
    numero_cliente: inventory.numero_cliente,
    nombre_cliente: Object.prototype.hasOwnProperty.call(inventory, 'nombre_cliente_legacy')
      ? inventory.nombre_cliente_legacy : inventory.nombre_cliente,
    fecha_creacion: inventory.fecha_creacion,
    path_gcs: inventory.path_gcs,
  };
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== null && value !== undefined) params.set(key, value);
  });
  return params;
}

export function captureKey(inventory) {
  return inventory.capture_uuid || `${inventory.id}:${captureParams(inventory)}`;
}

export function validateCapture(inventory, metadata) {
  const expected = captureParams(inventory);
  const mismatches = ['capture_uuid', 'proveedor', 'numero_cliente', 'fecha_creacion', 'path_gcs']
    .filter(field => expected.has(field) && (
      field === 'fecha_creacion'
        ? new Date(expected.get(field)).getTime() !== new Date(metadata[field]).getTime()
        : expected.get(field) !== String(metadata[field])
    ));
  if (inventory.nombre_cliente_legacy != null
      && inventory.nombre_cliente_legacy !== metadata.nombre_cliente) mismatches.push('nombre_cliente');
  if (inventory.id !== metadata.id) mismatches.push('id');
  if (mismatches.length) {
    throw new Error(`El detalle no corresponde a la captura seleccionada (${mismatches.join(', ')}). Actualiza el backend de inventarios.`);
  }
}
